<template>
  <v-card>
    <v-card-title class="d-flex">
      <v-icon start color="grey">mdi-filter</v-icon> Filter
      <v-icon @click="save" class="ml-auto" end color="grey">mdi-close</v-icon>
    </v-card-title>
    <v-card-text class="px-3 py-8">
      <v-form>
        <sorter
          v-model="sorts"
          :sortableFields="sortableFields"
          :SortTypes="SortTypes"
        />
      </v-form>
      <v-form :ref="form">
        <v-text-field
          v-model="fulltextSearch"
          variant="outlined"
          hide-details
          placeholder="Freitextsuche"
          clearable
          @click:clear="fulltextSearch = ''"
        />
        <v-select
          variant="plain"
          messages=""
          density="compact"
          :items="allSearchInItems"
          multiple
          item-title="text"
          item-value="value"
          v-model="filters.Fulltext$Fulltext.fields"
        >
          <template #selection="{ item }">
            <v-chip variant="outlined" class="black--color" color="grey" size="x-small">
              <span>{{ item.title }}</span>
            </v-chip>
          </template>
        </v-select>
        <v-select
          v-model="erledigt"
          item-title="text"
          item-value="value"
          :items="[{value: 'J', text: 'Ja'}, {value: 'N', text: 'Nein'}]"
          label="Erledigt"
          clearable
        />
      </v-form>
    </v-card-text>
    <v-divider></v-divider>

    <v-card-actions class="text-center">
      <v-btn color="grey" class="flex-1" variant="outlined" size="large" @click="reset">Zurücksetzen</v-btn>
      <v-btn class="flex-1 btn-navigator-primary" size="large" @click="save">Speichern</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script setup lang="ts">
import {computed, ref} from 'vue';
import Sorter from '../Sorter.vue';
import {FulltextSearchField, ValueType} from '@/api/meta/filters';
import {useFilterSort} from '@/composables/filterSort';
import useCRMOrderStore from '@/store/crmOrders';
import {VNodeRef} from 'vue';

const store = useCRMOrderStore();
const emits = defineEmits(['close']);
const {save, reset, filters, sorts, SortTypes} = useFilterSort(store, emits);

const allSearchInItems = ref<Array<{
      text: string;
      value: FulltextSearchField;
}>>([
  {
    text: 'Bestell-Nr.',
    value: {
      valueType: ValueType.NumberStartsWith,
      path: ['Nummer'],
    },
  },
  {
    text: 'Artikel-Nr.',
    value: {
      valueType: ValueType.StringContains,
      path: ['BestellungPosition', 'Artikel/ArtikelNr'],
    },
  },
  {
    text: 'Artikelbezeichnung 1',
    value: {
      valueType: ValueType.StringContains,
      path: ['BestellungPosition', 'Artikel/ArtikelBezeichnung1'],
    },
  },
  {
    text: 'Artikelbezeichnung 2',
    value: {
      valueType: ValueType.StringContains,
      path: ['BestellungPosition', 'Artikel/ArtikelBezeichnung2'],
    },
  },
]);

const sortableFields = ref([
  {
    text: 'Datum',
    value: 'Datum',
  },
]);
const form = ref<HTMLFormElement & VNodeRef | undefined>();

const fulltextSearch = computed({
  set(sWord: string) {
    const words = (sWord ?? '').split(' ').filter((w) => !!w);
    filters.value.Fulltext$Fulltext.words = words;
  },
  get(): string {
    const words = filters.value.Fulltext$Fulltext.words;

    return words?.join(' ') || '';
  },
});
const erledigt = computed({
  set(val: 'J' | 'N' | null | undefined) {
    filters.value.Erledigt = val ?? undefined;
  },
  get(): 'J' | 'N' | undefined {
    return filters.value.Erledigt;
  },
});

defineExpose({
  allSearchInItems,
  sortableFields,
  form,
  erledigt,
  fulltextSearch,
  save, reset, filters, sorts, SortTypes,
});

</script>
